export enum navTypes {
    basic, extended
}